




















import Vue from 'vue'
import * as Ux from '@/util/ux_message'

export default Vue.extend({
  data() {
    return {
      groupName: 'bottom-bubble',
      options: null as any | null,
    }
  },
  computed: {
    error() {
      return Ux.UxMessageType.ERROR
    },
    warning() {
      return Ux.UxMessageType.WARNING
    },
    info() {
      return Ux.UxMessageType.INFO
    },
     confirmation() {
      return Ux.UxMessageType.CONFIRMATION
    }
  },
  methods: {
    show(uxMessage: Ux.UxMessage) {
      const temp = { text: uxMessage.stack, ...uxMessage.options};
      this.$notify({ group: this.groupName,
          title: uxMessage.message,
          type : uxMessage.type,
          duration:6000, // put -1 for testing
          text: uxMessage.stack,
          data: uxMessage.options,
          ignoreDuplicates: uxMessage?.ignoreDuplicates ?? false
      });
    },
    clearAll() {
      this.$notify({ group: this.groupName, clean: true})
    },
    close(itemClose: any, options: any){
     if(options && options.callbackWithInfo) options.callbackWithInfo(options.returnInfo);
     if(itemClose) itemClose();
    }
  }
})
